import { createStore } from 'redux'
import middleware from './middleware'
import reducers from './reducer'
import initialState from './initial-state'

const store = createStore(reducers, initialState, middleware)

export default store
